import authReducer from "./authReducer";
import loadingReducer from "./loadingReducer";
import menuReducer from "./menuReducer";
import roleReducer from './roleReducer'
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import customizationReducer from "./customizationReducer";
import { rootReducer } from "./rootReducer";

// ==============================|| REDUX - MAIN STORE ||============================== //

const rootPersistConfig = {
  key: "rooterp",
  storage,
  blacklist: ["loading"],
};

// const reducer = combineReducers({
//   auth: authReducer,
//   role: roleReducer,
//   menu: menuReducer,
//   loading: loadingReducer,
//   customization: customizationReducer,
// });

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };

